import { useWeb3Modal } from "@web3modal/react";
import { useState, useEffect } from "react";
import { useAccount, useNetwork } from "wagmi";
import { useDisconnect } from "wagmi";
import { chainIds, networkName } from "../constants";
import useCustomToast from "./useToast";
import { useSwitchNetwork } from "wagmi";
import { setSignature } from "../../redux/user/action";
import { useDispatch } from "react-redux";

function useWalletConnect() {
  const { open } = useWeb3Modal();
  const { address, isConnected, isDisconnected } = useAccount();
  const { chain } = useNetwork();
  const [account, setAccount] = useState("");
  const [network, setNetwork] = useState("");
  // const { generateSignature, isSignIn } = useSignature();
  const { disconnect } = useDisconnect();
  const { switchNetwork, isSuccess } = useSwitchNetwork();
  const dispatch = useDispatch();

  const connectWallet = async () => open();
  useEffect(() => {
    if (isDisconnected) {
      localStorage.removeItem("signature");
      dispatch(setSignature(""));
    }
  }, [isDisconnected]);

  useEffect(() => {
    if (!!address) {
      setAccount(address?.toLowerCase());
      // if (!isSignIn) {
      //   console.log("geenrating signin")
      //   generateSignature();
      // }
    }
  }, [address]);
  useEffect(() => {
    const _networkName = networkName(chain?.id);
    if (!!_networkName) {
      setNetwork(_networkName);
    } else {
      setNetwork("");
    }
  }, [chain]);

  const changeNetwork = async (chainId) => {
    await switchNetwork?.(chainId);
  };
  return {
    isConnected,
    account,
    connectWallet,
    chain,
    network,
    changeNetwork,
    isNetworkChangeSuccess: isSuccess,
    disconnect,
  };
}

export default useWalletConnect;
